import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";

export function TuesdayPrepCard() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/dashboard/tuesday-prep").then((r) => setData(r.data)).catch(() => setData({ cleared: true }));
  }, []);

  if (!data || data.cleared) return null;

  const clear = async () => {
    setBusy(true);
    try {
      await api.post("/dashboard/tuesday-prep/clear");
      setData((d) => ({ ...d, cleared: true }));
      toast.success("Cleared — see you next Tuesday");
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };

  return (
    <div className="rounded-xl border border-primary/30 bg-white shadow-sm" data-testid="tuesday-prep-card">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-stone-100 px-5 py-4">
        <div>
          <p className="font-heading text-base font-semibold text-stone-900">Tuesday quality meeting — {data.tuesday} · 4:00 PM</p>
          <p className="mt-0.5 text-xs text-stone-500">Everything for this week's meeting in one place. Clear it after you meet.</p>
        </div>
        <div className="flex gap-2">
          {data.meeting_id && (
            <Link to={`/meetings/${data.meeting_id}`}>
              <Button size="sm" variant="outline" className="border-stone-300" data-testid="tuesday-prep-open-meeting">Open meeting room</Button>
            </Link>
          )}
          <Button size="sm" onClick={clear} disabled={busy}
            className="rounded-full bg-primary text-primary-foreground hover:bg-stone-900" data-testid="tuesday-prep-clear">
            {busy ? "Clearing…" : "Meeting held — clear"}
          </Button>
        </div>
      </div>
      <div className="grid gap-4 p-5 lg:grid-cols-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-stone-400">This week's agenda</p>
          <pre className="mt-2 max-h-72 overflow-y-auto whitespace-pre-wrap rounded-md bg-stone-50 p-3 text-xs text-stone-700" data-testid="tuesday-prep-agenda">{data.agenda}</pre>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-stone-400">EVV ladder movement this week</p>
          {data.ladder_changes?.length ? (
            <ul className="mt-2 space-y-1.5" data-testid="tuesday-prep-ladder">
              {data.ladder_changes.map((l) => (
                <li key={l.uid} className="rounded-md border border-stone-100 bg-stone-50 px-3 py-2 text-xs text-stone-700" data-testid={`tuesday-prep-ladder-${l.uid}`}>
                  <Link to={`/team/${l.uid}`} className="font-semibold text-stone-800 hover:text-primary hover:underline">{l.name}</Link>
                  {" — "}{l.step_label}
                </li>
              ))}
            </ul>
          ) : (
            <p className="mt-2 rounded-md bg-[#27AE60]/5 px-3 py-2 text-xs text-[#1e8449]" data-testid="tuesday-prep-ladder-none">Nobody on the ladder moved this week.</p>
          )}
          <p className="mt-4 text-xs text-stone-400">
            Uploads due Monday: raw visit report, EVV compliance report{new Date(data.tuesday).getDate() <= 7 ? ", and the monthly insurer report" : ""}. The reminder email tracks what arrived.
          </p>
        </div>
      </div>
    </div>
  );
}
